import { render, staticRenderFns } from "./physicsSeal.vue?vue&type=template&id=16474368&scoped=true"
import script from "./physicsSeal.vue?vue&type=script&lang=js"
export * from "./physicsSeal.vue?vue&type=script&lang=js"
import style0 from "./physicsSeal.vue?vue&type=style&index=0&id=16474368&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16474368",
  null
  
)

export default component.exports